"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GreatProfitRequest = void 0;
var GreatProfitRequest = /** @class */ (function () {
    function GreatProfitRequest() {
    }
    return GreatProfitRequest;
}());
exports.GreatProfitRequest = GreatProfitRequest;
;
//# sourceMappingURL=greatProfit.request.js.map